module.exports = __webpack_public_path__ + "img/icon-instagram.f9069b5c.svg";